import React, { useState } from 'react';
import GPSData from '../GPSData';
import MatchPerformance from '../gps/MatchPerformance';
import PlayerTeamTraining from './PlayerTeamTraining';
import { usePlayerData } from './PlayerDataContext';

const TABS = [
  { id: 'team-training',    label: 'Team Training'     },
  { id: 'match-performance', label: 'Match Performance' },
];

export default function PlayerTeam({ user, isMobile }) {
  const [active, setActive] = useState('team-training');
  const { playerRecord } = usePlayerData();

  const content = active === 'team-training'
    ? (isMobile ? <PlayerTeamTraining playerRecord={playerRecord} /> : <GPSData />)
    : <MatchPerformance user={user} />;

  return (
    <div style={{ maxWidth: 1400, margin: '0 auto' }}>
      <div style={{
        display: 'flex', gap: 6, padding: '12px 14px 0',
        overflowX: 'auto', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none',
      }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setActive(t.id)}
            style={{
              padding: '7px 14px', borderRadius: 99, cursor: 'pointer', fontFamily: 'inherit',
              border: active === t.id ? '1px solid #3b82f6' : '1px solid var(--border)',
              background: active === t.id ? '#3b82f6' : 'transparent',
              color: active === t.id ? '#fff' : 'var(--text-muted)',
              fontSize: 13, fontWeight: active === t.id ? 600 : 400, whiteSpace: 'nowrap', flexShrink: 0,
            }}>
            {t.label}
          </button>
        ))}
      </div>
      {content}
    </div>
  );
}
